import networkTS from '@/misc/apis/networkTS'

export default {
  async enable(accountId: string, enable: boolean) {
    return networkTS.firstcautionServiceEnable(accountId, { enable: enable })
      .then((response) => {
        return response.data
      })
  },
  async hasEnabled(accountId: string) {
    return networkTS.firstcautionServiceHasEnabled(accountId)
      .then((response) => {
        return response.data
      })
  },
  async openDeposit(objectId: string, tenancyId: string, contactPersonId: string = '') {
    return networkTS.firstcautionServiceOpenDeposit({
      objectId: objectId,
      tenancyId: tenancyId,
      contactPersonId: contactPersonId
    })
      .then((response) => {
        return response.data
      })
  },
  async getDepositInfo(tenancyId: string) {
    return networkTS.firstcautionServiceGetDepositInfo(tenancyId)
      .then((response) => {
        return response.data
      })
  }
}
